
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsPluGrid extends Serenity.Extensions.SelectableEntityGrid<CsPluRow, any> {
        protected getColumnsKey() { return CsPluColumns.columnsKey; }
        protected getDialogType() { return CsPluDialog; }
        protected getIdProperty() { return CsPluRow.idProperty; }
        protected getInsertPermission() { return CsPluRow.insertPermission; }
        protected getLocalTextPrefix() { return CsPluRow.localTextPrefix; }
        protected getService() { return CsPluService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            
                
                buttons.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
            // Add buttons export excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: CsPluService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }
    }
}